// Battery
jQuery(document).ready(function($) {

    var totalItems = $('.checklist-item').length;
    var clickedItems = 0;

    // Check knowledge
    $('.checklist-item').on('click', function() {
        $(this).toggleClass('active');
        $('.results-load[data-id*=' + $(this).attr('data-id') + ']')
            .toggleClass('active');
        $('.complement-item[data-id*=' + $(this).attr('data-id') + ']')
            .toggleClass('hidden');

        // Update clicked items count
        clickedItems = $('.checklist-item.active').length;

        // Calculate percentage
        var percentage = (clickedItems / totalItems) * 100;

        // Update the content of the .procent-nr div
        $('.procent-nr').text(percentage.toFixed(0) + '%');

    });

    // Check results
    $('#testMe').on('click', function() {
        var hidden_field = $('#input_1_2');

        var hiddenFieldValue = '';

        var complementItems = $('.complement-item:not(.hidden)');
        complementItems.each(function() {
            hiddenFieldValue += '<p>' + $(this).html() + '</p>';
        });

        hidden_field.val(hiddenFieldValue);

        // Check active items
        var allActive = $('.checklist-item').toArray().every(function(item) {
            return $(item).hasClass('active');
        });

        // Show correct popup
        if (allActive) {
            $('.battery-popup.success').addClass('active');
            $('.battery').addClass('active');
            console.log('Success');
        } else {
            $('.battery-popup.fail').addClass('active');
            $('.battery').addClass('active');
            console.log('Fail');
        }

        // Close popup
        $('.battery-popup .close').on('click', function() {
            $('.battery-popup.success').removeClass('active');
            $('.battery-popup.fail').removeClass('active');
            $('.battery').removeClass('active');
            console.log('close close');
        });
        $('.battery .overlay').on('click', function() {
            $('.battery-popup.success').removeClass('active');
            $('.battery-popup.fail').removeClass('active');
            $('.battery').removeClass('active');
        });
    });

});